import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { colors } from '@lifesize/ux-assets';
import { hooks } from '@lifesize/clients.sdk';
import { ReactComponent as PresentIcon } from '@lifesize/ux-assets/vectors/svgIcons/share-screen.svg';
import { makeStyles, Theme, Tooltip } from '@material-ui/core';
import Modals from 'constants/Modals';
import { openInCallModal } from 'actions/InCallModal';

interface props {
  participant: any;
}

export const ParticipantPresentationButton = ({ participant }: props) => {
  const classes = useStyles({});
  const userIsModerator = hooks.useIsCurrentUserModerator();
  const { isPresenting } = participant;
  const dispatch = useDispatch();

  const handleStopPresenterClicked = (participant) => {
    dispatch(openInCallModal(Modals.stopPresenter, { participant }));
  };

  if (!isPresenting) return null;
  if (userIsModerator) {
    return (
      <Tooltip
        arrow={true}
        placement="top"
        title={
          <FormattedMessage
            id="components.inCall.participantDrawer.endPresentation"
            defaultMessage="End Presentation"
          />
        }
      >
        <button className={classes.button} onClick={() => handleStopPresenterClicked(participant)}>
          <PresentIcon className={`${classes.buttonIcon} ${classes.presenterIcon}`} data-testid="menuIconPresent" />
        </button>
      </Tooltip>
    );
  }
  return (
    <div className={`${classes.button} ${classes.noButton}`}>
      <PresentIcon className={`${classes.buttonIcon} ${classes.presenterIcon}`} data-testid="menuIconPresent" />
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    alignItems: 'center',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '1em', // prevents global button default
    height: '100%', // necessary for the drop-down button
    justifyContent: 'center',
    margin: '0 3px',
    outline: 'none',
    padding: 0,
    position: 'relative',
    width: '2em'
  },
  noButton: {
    cursor: 'default'
  },
  buttonIcon: {
    height: '2em',
    width: 'auto'
  },
  presenterIcon: {
    color: colors.agileGreen
  }
}));

export default ParticipantPresentationButton;
